import React from "react";
import { useForm, useSteps } from "@/Components/formik-steps";
import { dateToHumanReadableString } from "../../helpers";

export function showIcon(value) {
  if (value === "Banden reparatie") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_157_4273)">
          <path
            d="M14.4997 4.83331C9.16958 4.83331 4.83301 9.16989 4.83301 14.5C4.83301 19.8301 9.16958 24.1667 14.4997 24.1667C19.8298 24.1667 24.1664 19.8301 24.1664 14.5C24.1664 9.16989 19.8298 4.83331 14.4997 4.83331ZM19.4452 8.44415C19.5537 8.32322 19.7071 8.2518 19.87 8.24534C20.0104 8.22943 20.1909 8.29785 20.3089 8.40994C21.5621 9.59645 22.4141 11.1069 22.7704 12.7778C22.8271 13.0444 22.6984 13.3159 22.4565 13.4409C21.8653 13.7466 21.1632 13.8946 20.4906 13.8946C19.6139 13.8946 18.7831 13.6433 18.3017 13.1618C17.2775 12.1382 17.7046 10.3747 19.4452 8.44415ZM9.55429 20.6502C9.44571 20.7711 9.29232 20.8431 9.12948 20.8496C9.1224 20.8502 9.11413 20.8502 9.10586 20.8502C8.95129 20.8502 8.80261 20.7912 8.69052 20.685C7.43734 19.4985 6.58536 17.988 6.22903 16.3166C6.17239 16.0499 6.30102 15.7785 6.54293 15.6534C7.90469 14.9507 9.84695 15.0817 10.6977 15.9325C11.7208 16.9562 11.2936 18.7197 9.55429 20.6502ZM10.6977 13.1619C10.2162 13.6433 9.3855 13.8947 8.50876 13.8947C7.83615 13.8947 7.13522 13.7466 6.54288 13.441C6.30096 13.3159 6.17233 13.0445 6.22897 12.7778C6.58536 11.1069 7.43729 9.59651 8.69046 8.41C8.80844 8.29791 8.98193 8.2283 9.12943 8.2454C9.29227 8.25191 9.44565 8.32328 9.55423 8.44421C11.2948 10.3747 11.7219 12.1382 10.6977 13.1619ZM17.0745 22.5566C16.2378 22.8232 15.3717 22.9584 14.4997 22.9584C13.6277 22.9584 12.7615 22.8233 11.9249 22.5566C11.6594 22.4716 11.486 22.2167 11.5048 21.9388C11.6559 19.7646 12.9433 18.125 14.4997 18.125C16.0561 18.125 17.3435 19.7646 17.4946 21.9388C17.5134 22.2167 17.34 22.4716 17.0745 22.5566ZM12.083 14.5C12.083 13.1672 13.1674 12.0833 14.4997 12.0833C15.8319 12.0833 16.9164 13.1671 16.9164 14.5C16.9164 15.8329 15.8319 16.9167 14.4997 16.9167C13.1674 16.9167 12.083 15.8328 12.083 14.5ZM17.4946 7.10896C17.3435 9.28255 16.0561 10.9222 14.4997 10.9222C12.9433 10.9222 11.6559 9.28255 11.5048 7.10896C11.486 6.83108 11.6582 6.5762 11.9237 6.49181C13.597 5.95723 15.4024 5.95723 17.0757 6.49181C17.3412 6.5762 17.5134 6.83108 17.4946 7.10896ZM22.7704 16.2205C22.414 17.8919 21.5621 19.4024 20.3089 20.5889C20.1968 20.6951 20.0482 20.7541 19.8936 20.7541C19.8853 20.7541 19.877 20.7541 19.87 20.7535C19.7071 20.747 19.5537 20.6756 19.4452 20.5547C17.7046 18.6242 17.2775 16.8601 18.3017 15.8364C19.1525 14.9851 21.0936 14.8558 22.4565 15.5574C22.6984 15.6824 22.8271 15.9538 22.7704 16.2205Z"
            fill="#070707"
          />
          <path
            d="M14.5 0C6.50421 0 0 6.50484 0 14.5C0 22.4952 6.50421 29 14.5 29C22.4958 29 29 22.4952 29 14.5C29 6.50484 22.4958 0 14.5 0ZM14.5 25.375C8.50317 25.375 3.625 20.4963 3.625 14.5C3.625 8.50374 8.50317 3.625 14.5 3.625C20.4968 3.625 25.375 8.50374 25.375 14.5C25.375 20.4963 20.4968 25.375 14.5 25.375Z"
            fill="#070707"
          />
        </g>

        <defs>
          <clipPath id="clip0_157_4273">
            <rect width="29" height="29" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  } else if (value === "APK") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="40" height="40" rx="8" fill="" />
        <path
          d="M27.9926 8.79954H25.369V7.62583C25.369 7.2461 24.9548 7.07351 24.575 7.07351H22.5383C22.055 5.69266 20.8468 5.00224 19.4659 5.00224C18.1003 4.95089 16.8581 5.78827 16.3936 7.07351H14.3913C14.0116 7.07351 13.6319 7.2461 13.6319 7.62583V8.79954H11.0082C9.45343 8.81612 8.18148 10.0426 8.1084 11.5957V31.3763C8.1084 32.8953 9.48925 33.9999 11.0082 33.9999H27.9926C29.5116 33.9999 30.8924 32.8953 30.8924 31.3763V11.5958C30.8193 10.0426 29.5474 8.81612 27.9926 8.79954ZM15.0126 8.45436H16.9113C17.2428 8.41392 17.509 8.16177 17.5673 7.83298C17.7717 6.94268 18.5528 6.30359 19.4659 6.27954C20.3706 6.30696 21.14 6.94803 21.3301 7.83298C21.392 8.17314 21.6758 8.42852 22.0205 8.45436H23.9882V11.2161H15.0126V8.45436ZM29.5116 31.3764C29.5116 32.1359 28.7521 32.6191 27.9926 32.6191H11.0082C10.2487 32.6191 9.48925 32.1359 9.48925 31.3764V11.5958C9.55968 10.8053 10.2146 10.1949 11.0082 10.1804H13.6318V11.941C13.6683 12.3278 14.0033 12.6172 14.3913 12.597H24.575C24.9701 12.6186 25.3156 12.3332 25.3689 11.941V10.1804H27.9925C28.786 10.1949 29.441 10.8052 29.5115 11.5957V31.3764H29.5116Z"
          fill="#070707"
        />
        <path
          d="M16.8426 20.4332C16.5837 20.1602 16.1538 20.1448 15.876 20.3987L13.6666 22.5045L12.7346 21.5379C12.4756 21.2649 12.0457 21.2496 11.7679 21.5034C11.5005 21.7835 11.5005 22.2243 11.7679 22.5045L13.1833 23.9544C13.3058 24.0915 13.4827 24.1674 13.6666 24.1615C13.8487 24.1589 14.0224 24.0845 14.1498 23.9544L16.8425 21.3998C17.1094 21.1549 17.1273 20.74 16.8823 20.4731C16.8698 20.4592 16.8565 20.4459 16.8426 20.4332Z"
          fill="#070707"
        />
        <path
          d="M26.7494 21.9176H18.8096C18.4282 21.9176 18.1191 22.2267 18.1191 22.608C18.1191 22.9893 18.4282 23.2985 18.8096 23.2985H26.7494C27.1307 23.2985 27.4398 22.9893 27.4398 22.608C27.4398 22.2267 27.1307 21.9176 26.7494 21.9176Z"
          fill="#070707"
        />
        <path
          d="M16.8426 14.9098C16.5837 14.6369 16.1538 14.6215 15.876 14.8753L13.6666 16.9811L12.7346 16.0145C12.4756 15.7415 12.0457 15.7261 11.7679 15.98C11.5005 16.2601 11.5005 16.7009 11.7679 16.9811L13.1833 18.431C13.3058 18.5682 13.4827 18.644 13.6666 18.6381C13.8487 18.6356 14.0224 18.5611 14.1498 18.431L16.8425 15.8764C17.1094 15.6316 17.1273 15.2166 16.8823 14.9497C16.8698 14.9358 16.8565 14.9225 16.8426 14.9098Z"
          fill="#070707"
        />
        <path
          d="M26.7494 16.3942H18.8096C18.4282 16.3942 18.1191 16.7033 18.1191 17.0846C18.1191 17.4659 18.4282 17.775 18.8096 17.775H26.7494C27.1307 17.775 27.4398 17.4659 27.4398 17.0846C27.4398 16.7033 27.1307 16.3942 26.7494 16.3942Z"
          fill="#070707"
        />
        <path
          d="M16.8426 25.9565C16.5837 25.6836 16.1538 25.6682 15.876 25.922L13.6666 28.0278L12.7346 27.0612C12.4756 26.7882 12.0457 26.7729 11.7679 27.0267C11.5005 27.3068 11.5005 27.7476 11.7679 28.0278L13.1833 29.4777C13.3058 29.6149 13.4827 29.6907 13.6666 29.6848C13.8487 29.6823 14.0224 29.6078 14.1498 29.4777L16.8425 26.9231C17.1094 26.6783 17.1273 26.2633 16.8823 25.9964C16.8698 25.9826 16.8565 25.9693 16.8426 25.9565Z"
          fill="#070707"
        />
        <path
          d="M26.7494 27.441H18.8096C18.4282 27.441 18.1191 27.7501 18.1191 28.1314C18.1191 28.5127 18.4282 28.8218 18.8096 28.8218H26.7494C27.1307 28.8218 27.4398 28.5127 27.4398 28.1314C27.4398 27.7501 27.1307 27.441 26.7494 27.441Z"
          fill="#070707"
        />
      </svg>
    );
  } else if (value === "Bandenwissel") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_157_5638)">
          <path
            d="M8.05276 10.9192L9.98219 13.1242L12.39 10.3726L10.7804 8.53322C9.05902 6.56497 6.57304 5.43744 3.96045 5.43744H0V9.06242H3.96045C5.52781 9.06247 7.0199 9.73866 8.05276 10.9192Z"
            fill="#070707"
          />
          <path
            d="M23.5626 19.9375H23.2272C21.6598 19.9375 20.1677 19.2614 19.1349 18.0807L16.0015 14.5L19.1349 10.9192C20.1677 9.73858 21.6598 9.06246 23.2272 9.06246H23.5626V12.6874L29 7.2498L23.5626 1.8125V5.43748H23.2272C20.6146 5.43748 18.1286 6.56495 16.4072 8.53326L8.0527 18.0807C7.0199 19.2613 5.52775 19.9375 3.9604 19.9375H0V23.5625H3.96045C6.57299 23.5625 9.05902 22.435 10.7804 20.4667L13.5938 17.2515L16.4073 20.4667C18.1287 22.435 20.6146 23.5625 23.2272 23.5625H23.5626V27.1875L29.0001 21.7501L23.5626 16.3125V19.9375Z"
            fill="#070707"
          />
        </g>
        <defs>
          <clipPath id="clip0_157_5638">
            <rect width="29" height="29" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  } else if (value === "Occasion bezichtigen") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0"
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 190"
        enableBackground="new 0 0 256 190"
      >
        <path
          d="M48.12,27.903C48.12,13.564,59.592,2,74.023,2c14.339,0,25.903,11.564,25.903,25.903
          C99.834,42.335,88.27,53.806,74.023,53.806C59.684,53.806,48.12,42.242,48.12,27.903z M191,139h-47V97c0-20.461-17.881-37-38-37H43
          C20.912,60,1.99,79.14,2,98v77c-0.026,8.533,6.001,12.989,12,13c6.014,0.011,12-4.445,12-13v-75h8v88h78v-88h8l0.081,50.37
          c-0.053,8.729,5.342,12.446,10.919,12.63h60C207.363,163,207.363,139,191,139z M230.839,110.811v7.724
          c0,4.319,3.405,7.724,7.724,7.724c4.236,0,7.724-3.405,7.724-7.724v-7.724h7.89V85.563l0,0c0-5.564-3.737-10.132-8.803-11.544
          l-8.969-21.51c-1.329-3.156-4.402-5.398-8.056-5.398h-46.259c-3.654,0-6.727,2.242-8.056,5.398l-9.053,21.51
          c-5.066,1.412-8.803,5.98-8.803,11.544l0,0v25.247h7.807v7.724c0,4.319,3.488,7.724,7.724,7.724c4.236,0,7.724-3.405,7.724-7.724
          v-7.724H230.839z M172.205,96.941c-4.319,0-7.807-3.488-7.807-7.807s3.488-7.807,7.807-7.807c4.319,0,7.807,3.488,7.807,7.807
          C180.012,93.453,176.524,96.941,172.205,96.941 M245.456,89.134c0,4.319-3.488,7.807-7.807,7.807s-7.807-3.488-7.807-7.807
          s3.488-7.807,7.807-7.807S245.456,84.816,245.456,89.134 M172.787,73.604L180.51,55c0.332-0.914,1.246-1.578,2.242-1.578H227.6
          c1.08,0,1.993,0.664,2.325,1.578l7.724,18.603L172.787,73.604z"
        />
      </svg>
    );
  } else if (value === "Airco controle") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M18.91,11.09A7.84,7.84,0,0,0,22,12v2A9.37,9.37,0,0,1,18.17,13l-.08,0A7.84,7.84,0,0,0,15,12a6.15,6.15,0,0,0-2.8.89l-.06,0A8.54,8.54,0,0,1,9,14V12a7.59,7.59,0,0,0,2.3-.86l.06,0A7.86,7.86,0,0,1,15,10a9.37,9.37,0,0,1,3.83,1.05Zm-.08,4A9.37,9.37,0,0,0,15,14a7.86,7.86,0,0,0-3.64,1.08l-.06,0A7.59,7.59,0,0,1,9,16v2a8.54,8.54,0,0,0,3.14-1.06l.06,0A6.15,6.15,0,0,1,15,16a7.84,7.84,0,0,1,3.09.91l.08,0A9.53,9.53,0,0,0,22,18V16a7.84,7.84,0,0,1-3.09-.91ZM19,7.13V4a2,2,0,0,0-2-2H7A2,2,0,0,0,5,4V7.17A9,9,0,0,0,2,6.5v2a8.26,8.26,0,0,1,2.63.66l.1,0L5,9.28v1.89a9,9,0,0,0-3-.67v2a8.26,8.26,0,0,1,2.63.66l.1,0,.27.09v1.89a9,9,0,0,0-3-.67v2a8.26,8.26,0,0,1,2.63.66l.1,0,.27.09V20a2,2,0,0,0,2,2H17a2,2,0,0,0,2-2v-.69L18.17,19l-.08,0c-.38-.17-.74-.33-1.09-.46V20H7V4H17V6.33A6.81,6.81,0,0,0,15,6a7.86,7.86,0,0,0-3.64,1.08l-.06,0A7.59,7.59,0,0,1,9,8v2a8.54,8.54,0,0,0,3.14-1.06l.06,0A6.15,6.15,0,0,1,15,8a7.84,7.84,0,0,1,3.09.91l.08,0A9.53,9.53,0,0,0,22,10V8A7.63,7.63,0,0,1,19,7.13Z" />
        <rect width="24" height="24" fill="none" />
      </svg>
    );
  } else if (value === "Autostatus update") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        fill="#000000"
        version="1.1"
        id="Icons"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
      >
        <path
          d="M8.4,22l1.2-2.3c0.5-1,1.5-1.7,2.7-1.7h3.5c0.1,0,0.2,0,0.2,0c1.8-2.4,4.7-4,8-4c1.2,0,2.3,0.2,3.4,0.6
          C27,14,26.5,13.4,26,13h1c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2.8L23,8c-0.8-1.8-2.6-3-4.6-3H9.6C7.6,5,5.8,6.2,5,8l-1.3,3H1
          c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c-1.2,0.9-2,2.4-2,4v4c0,0.9,0.4,1.7,1,2.2V25c0,1.7,1.3,3,3,3h2c1.7,0,3-1.3,3-3v-1h5
          c0-0.7,0.1-1.4,0.2-2H8.4z M7,19H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h3c0.6,0,1,0.4,1,1S7.6,19,7,19z M5.5,12l1.4-3.2C7.4,7.7,8.4,7,9.6,7
          h8.7c1.2,0,2.3,0.7,2.8,1.8l1.4,3.2H5.5z"
        />

        <path
          d="M31.7,21.9c-0.1-0.5-0.7-0.8-1.2-0.7c-0.7,0.2-1.2,0-1.3-0.2c-0.1-0.2,0-0.7,0.5-1.3c0.4-0.4,0.4-1,0-1.4
          c-1-1-2.2-1.7-3.6-2.1c-0.5-0.1-1.1,0.2-1.2,0.7c-0.2,0.7-0.6,1-0.9,1s-0.6-0.4-0.9-1c-0.2-0.5-0.7-0.8-1.2-0.7
          c-1.4,0.4-2.6,1.1-3.6,2.1c-0.4,0.4-0.4,1,0,1.4c0.5,0.5,0.6,1,0.5,1.3c-0.1,0.2-0.6,0.4-1.3,0.2c-0.5-0.1-1.1,0.2-1.2,0.7
          C16.1,22.6,16,23.3,16,24s0.1,1.4,0.3,2.1c0.1,0.5,0.7,0.8,1.2,0.7c0.7-0.2,1.2,0,1.3,0.2c0.1,0.2,0,0.7-0.5,1.3
          c-0.4,0.4-0.4,1,0,1.4c1,1,2.2,1.7,3.6,2.1c0.5,0.1,1.1-0.2,1.2-0.7c0.2-0.7,0.6-1,0.9-1s0.6,0.4,0.9,1c0.1,0.4,0.5,0.7,1,0.7
          c0.1,0,0.2,0,0.3,0c1.4-0.4,2.6-1.1,3.6-2.1c0.4-0.4,0.4-1,0-1.4c-0.5-0.5-0.6-1-0.5-1.3c0.1-0.2,0.6-0.4,1.3-0.2
          c0.5,0.1,1.1-0.2,1.2-0.7c0.2-0.7,0.3-1.4,0.3-2.1S31.9,22.6,31.7,21.9z M24,27c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S25.7,27,24,27
          z"
        />
      </svg>
    );
  } else if (value === "Zomercheck") {
    return (
      <svg
        fill="#000000"
        className="w-[40px] h-[40px] shrink-0 cf-icon-svg "
        viewBox="-1 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M2.866 10.052H1.277a.554.554 0 0 1 0-1.109h1.589a.554.554 0 0 1 0 1.109zm1.65-3.984a.552.552 0 0 1-.392-.162L3.001 4.782a.554.554 0 0 1 .784-.784l1.123 1.124a.554.554 0 0 1-.392.946zm-1.123 9.09A.554.554 0 0 1 3 14.214l1.123-1.124a.554.554 0 0 1 .784.784l-1.123 1.123a.552.552 0 0 1-.392.163zm9.568-5.66a4.453 4.453 0 1 1-4.454-4.454 4.453 4.453 0 0 1 4.454 4.453zM8.5 4.417a.554.554 0 0 1-.554-.555V2.275a.554.554 0 1 1 1.108 0v1.588a.554.554 0 0 1-.554.555zm0 12.856a.554.554 0 0 1-.554-.554v-1.588a.554.554 0 0 1 1.108 0v1.588a.554.554 0 0 1-.554.554zm3.984-11.206a.554.554 0 0 1-.392-.946l1.123-1.123a.554.554 0 0 1 .784.783l-1.123 1.123a.551.551 0 0 1-.392.163zm1.123 9.09a.553.553 0 0 1-.392-.162l-1.123-1.123a.554.554 0 0 1 .784-.784l1.123 1.124a.554.554 0 0 1-.392.946zm2.116-5.106h-1.589a.554.554 0 0 1 0-1.109h1.589a.554.554 0 0 1 0 1.109z" />
      </svg>
    );
  } else if (value === "Wintercheck") {
    return (
      <svg
        fill="#000000"
        className="w-[40px] h-[40px] shrink-0 icon multi-color "
        viewBox="0 0 24 24"
        id="winter-ice"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="primary-stroke"
          d="M12,3v7m9,2H14m-2,9V14M3,12h7m0,0a2,2,0,1,0,2-2A2,2,0,0,0,10,12Zm5-7L12,7,9,5M19,9l-2,3,2,3m-4,4-3-2L9,19M5,15l2-3L5,9"
          style={{
            fill: "none",
            stroke: "rgb(0, 0, 0)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
          }}
        ></path>
      </svg>
    );
  } else if (value === "Grote beurt") {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        viewBox="0 0 512 512"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#000000"
          d="M426.24 30c-13.635.02-38.617 9.837-47.707 20H68.24c-32 0-32 64 0 64h310.301c9.088 10.16 34.067 19.978 47.7 20 17.123-.025 32.937-13.17 41.5-28h-39.5l-22-24 22-24h39.519c-8.565-14.835-24.39-27.982-41.52-28zm-342 36c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.836 0-16-7.163-16-16s7.164-16 16-16zm75.77 117c-8 0-13.83 4.038-20.166 8.813-6.336 4.774-12.98 10.944-20.041 17.67-13.752 13.096-29.103 28.29-43.608 38.218l45.407 1.135c11.17-20.948 18.277-40.386 38.408-47.836h71v50.572l18 .45V201h23c11.5 0 30.948 10.484 50.377 26.027 10.483 8.387 21.064 18.01 31.117 27.608l49.611 1.24 49.729-58.018-13.668-11.714-59.237 69.109c-13.952-13.825-29.952-29.196-46.306-42.28C313.06 196.517 292.51 183 272.01 183h-112zM47.986 265.004c-4.995.008-11.034 2.78-15.613 7.36C27.787 276.948 25.01 283 25.01 288c0 13 7.276 32.26 16.633 47.23 4.355 6.97 9.123 13.056 13.38 17.313-.001-.182-.013-.36-.013-.543 0-31.374 25.626-57 57-57 31.373 0 57 25.626 57 57 0 2.37-.163 4.704-.447 7h190.894a56.952 56.952 0 0 1-.447-7c0-31.374 25.626-57 57-57 31.373 0 57 25.626 57 57 0 2.37-.163 4.704-.447 7h9.392l5.035-45.326c-.106-12.823-6.276-21.985-14.603-28.647-8.4-6.72-19.377-10.027-24.377-10.027h-.114l-399.91-9.996zM112.01 313c-21.646 0-39 17.354-39 39s17.354 39 39 39c21.645 0 39-17.354 39-39s-17.355-39-39-39zm304 0c-21.646 0-39 17.354-39 39s17.354 39 39 39c21.645 0 39-17.354 39-39s-17.355-39-39-39zm-215 64v14h110v-14h-110zm48 32v46h14v-46h-14zm-35.438 64l-7 14h98.875l-7-14h-84.875z"
        />
      </svg>
    );
  } else if (value === "Kleine beurt") {
    return (
      <svg
        fill="#000000"
        className="w-[40px] h-[40px] shrink-0 "
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 511.999 511.999"
      >
        <g>
          <g>
            <path
              d="M368.359,481.005h-51.493V451.46c-3.516,1.078-7.24,1.72-11.096,1.873c-1.814,0.072-10.131,0.248-19.896,0.412v22.832
              c3.521,8.895,8.023,17.473,3.809,30.078c2.841,3.267,7.018,5.343,11.687,5.343h66.989c8.557,0,15.496-6.938,15.496-15.496
              C383.855,487.942,376.916,481.005,368.359,481.005z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M305.612,320.076l-6.581,0.047l9.397,14.764c0,0-8.706-8.43-50.508-46.681l-20.582-48.023
              c-2.809-6.555-10.398-9.592-16.955-6.782c-6.555,2.809-9.591,10.4-6.782,16.955l21.691,50.611
              c0.731,1.705,1.821,3.234,3.196,4.479c37.863,34.271,51.57,46.544,51.57,46.544l-25.088-14.342v68.78l-35.327-0.105
              c-0.006,0-0.011,0-0.017,0c-0.01,0-0.019,0-0.029,0c-10.923,0-18.43,11.032-14.408,21.198l29.551,74.68
              c3.159,7.982,12.456,12.17,20.798,8.393c7.484-3.387,11.074-12.076,8.019-19.796l-21.139-53.416c0,0,39.67,0.116,53.416,0
              c11.262-0.095,21.319-9.706,21.354-22.283l0.201-73.34C327.423,329.64,317.505,319.983,305.612,320.076z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M307.03,277.526c-2.377-15.56-16.919-26.248-32.478-23.871c-4.859,0.742-9.241,2.671-12.901,5.445l10.756,25.097
			        l17.667,23.84C301.744,303.051,309.035,290.652,307.03,277.526z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M492.927,484.979h-16.685V267.248h12.792c6.301,0,11.41-5.109,11.41-11.41c0-6.301-5.109-11.41-11.41-11.41h-12.792
            V16.685C476.242,7.47,468.772,0,459.557,0s-16.685,7.47-16.685,16.685v227.742h-66.696v-12.295
            c15.029,0,23.325-10.518,23.325-21.622v-44.95c0-15.885-6.415-30.27-16.791-40.714l-0.725-3.89l11.602-12.232h23.001
            c6.757,0,12.236-5.478,12.236-12.236v-9.31c0-6.757-5.478-12.236-12.236-12.236h-24.16c-6.757,0-12.236,5.478-12.236,12.236
            c0,9.456-0.038,9.574,0.067,10.581l-2.172,2.29l-15.434-82.741c-1.008-5.401-5.723-9.318-11.217-9.318H160.808
            c-5.494,0-10.209,3.917-11.217,9.318l-15.475,82.955l-2.375-2.504c0.103-1.004,0.066-1.127,0.066-10.581
            c0-6.757-5.478-12.236-12.236-12.236h-24.16c-6.757,0-12.236,5.478-12.236,12.236v9.31c0,6.757,5.478,12.236,12.236,12.236h23.001
            l11.804,12.446l-0.686,3.677c-10.376,10.444-16.79,24.828-16.79,40.714v44.95c0,10.866,8.041,21.622,23.326,21.622v12.295H69.127
            V16.685C69.127,7.47,61.656,0,52.442,0S35.757,7.47,35.757,16.685v227.742H22.965c-6.301,0-11.41,5.109-11.41,11.41
            c0,6.301,5.109,11.41,11.41,11.41h12.792v217.731H19.072c-3.071,0-5.562,2.491-5.562,5.562v15.573
            c0,3.071,2.491,5.562,5.562,5.562h33.37h33.37c3.071,0,5.562-2.491,5.562-5.562v-15.573c0-3.071-2.491-5.562-5.562-5.562H69.127
            V267.248h69.244c4.19,9.458,13.654,16.061,24.665,16.061c14.895,0,26.97-12.074,26.97-26.97v-24.207h10.962
            c2.874-5.368,7.516-9.836,13.548-12.423c13.366-5.727,28.725-0.166,35.457,12.423h72.264v24.207
            c0,14.895,12.074,26.97,26.97,26.97c11.011,0,20.475-6.603,24.665-16.061h69.001v217.731h-16.685
            c-3.071,0-5.562,2.491-5.562,5.562v15.573c0,3.071,2.491,5.562,5.562,5.562h33.37h33.37c3.071,0,5.562-2.491,5.562-5.562v-15.573
            C498.489,487.47,495.999,484.979,492.927,484.979z M162.32,194.887c-13.067,0-23.659-10.599-23.659-23.674
            s10.593-23.674,23.659-23.674s23.659,10.599,23.659,23.674S175.386,194.887,162.32,194.887z M282.726,213.426h-53.211
            c-4.754,0-8.608-3.854-8.608-8.609s3.854-8.609,8.608-8.609h53.211c4.754,0,8.608,3.854,8.608,8.609
            S287.481,213.426,282.726,213.426z M296.94,180.625h-81.639c-4.754,0-8.608-3.854-8.608-8.609s3.854-8.609,8.608-8.609h81.639
            c4.754,0,8.608,3.854,8.608,8.609S301.694,180.625,296.94,180.625z M283.34,107.79c1.307-9.064,9.104-16.06,18.525-16.06
            c9.42,0,17.217,6.994,18.524,16.06H283.34z M301.865,72.713c-19.916,0-36.269,15.505-37.649,35.076h-93.703
            c-5.172,0-10.181,0.69-14.951,1.964l14.726-78.944h63.601c-1.076,1.592-1.704,3.51-1.704,5.576c0,5.506,4.464,9.97,9.97,9.97
            h27.935c5.506,0,9.97-4.464,9.97-9.97c0-2.066-0.628-3.984-1.704-5.576h63.601l14.725,78.944
            c-7.455-1.992-12.9-1.964-17.168-1.964C338.133,88.218,321.782,72.713,301.865,72.713z M349.922,194.887
            c-13.067,0-23.659-10.599-23.659-23.674s10.593-23.674,23.659-23.674c13.067,0,23.659,10.599,23.659,23.674
            S362.989,194.887,349.922,194.887z"
            />
          </g>
        </g>
      </svg>
    );
  } else {
    return (
      <svg
        className="w-[40px] h-[40px] shrink-0 "
        fill="#000000"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 256 173"
        enableBackground="new 0 0 256 173"
      >
        <path
          d="M128.253,56.864c15.186,0,27.432-12.247,27.432-27.432S143.536,2,128.253,2
          c-15.186,0-27.432,12.247-27.432,27.432C100.918,44.716,113.165,56.864,128.253,56.864z M64.571,136.32h-49.28
          c-15.969,0-16.851-24.395,0.294-24.395H58.3l24.493-36.054c7.25-9.895,15.48-14.598,27.138-14.598h36.544
          c11.659,0,19.888,4.311,27.138,14.598l24.591,36.054h43.01c17.243,0,16.165,24.395,0.588,24.395h-49.28
          c-3.919,0-8.622-1.372-11.365-5.584l-18.811-26.844l-0.098,67.209H94.844l-0.098-67.209l-18.811,26.844
          C73.192,134.85,68.49,136.32,64.571,136.32z"
        />
        <path
          d="M15.763,83.779v4.571c0,2.556-2.064,4.571-4.571,4.571S6.62,90.906,6.62,88.35v-4.571H2V68.836l0,0
          c0-3.293,2.212-5.997,5.21-6.832l5.358-12.731c0.786-1.868,2.605-3.195,4.768-3.195h27.378c2.163,0,3.981,1.327,4.768,3.195
          l5.308,12.731C57.788,62.84,60,65.543,60,68.836l0,0v14.942h-4.669v4.571c0,2.556-2.064,4.571-4.571,4.571
          c-2.556,0-4.571-2.015-4.571-4.571v-4.571H15.763z M11.486,75.57c2.556,0,4.62-2.064,4.62-4.62c0-2.556-2.064-4.62-4.62-4.62
          s-4.62,2.064-4.62,4.62S8.931,75.57,11.486,75.57 M54.839,70.95c0-2.556-2.064-4.62-4.62-4.62c-2.556,0-4.62,2.064-4.62,4.62
          s2.064,4.62,4.62,4.62S54.839,73.506,54.839,70.95 M50.219,61.758l-4.571-11.01c-0.197-0.541-0.737-0.934-1.376-0.934H17.729
          c-0.59,0-1.131,0.393-1.327,0.934l-4.571,11.01H50.219z"
        />
        <path
          d="M244.996,84.824c-1.536-1.394-3.332-2.032-5.436-1.962c-0.709,0-1.394,0.165-2.103,0.402l-10.54-9.642
          l6.783-8.012l10.777,9.501L254,64.263l-26.966-23.728l-9.524,10.848l10.493,9.241l-7.019,7.586l-9.595-8.792
          c0.165-0.709,0.236-1.394,0.165-2.103c-0.071-2.103-0.898-3.9-2.434-5.27c-1.536-1.394-3.332-2.032-5.436-1.962
          c-0.709,0-1.465,0.165-2.103,0.402l6.097,5.53l-5.388,5.908l-6.097-5.53c-0.165,0.709-0.236,1.465-0.165,2.103
          c0.071,2.103,0.898,3.805,2.434,5.199c1.536,1.394,3.332,2.032,5.436,1.962c0.709,0,1.536-0.165,2.269-0.496l9.312,8.532
          l-15.409,15.976c-1.064,0.898-1.607,2.174-1.607,3.569c0,2.6,2.103,4.703,4.703,4.703c1.607,0,3.001-0.827,3.9-2.032l14.842-16.354
          l8.768,8.012l1.465,1.394c-0.165,0.709-0.236,1.536-0.236,2.269c0.071,2.103,0.898,3.805,2.434,5.27
          c1.536,1.394,3.332,2.032,5.436,1.962c0.709,0,1.394-0.165,2.103-0.402l-6.097-5.53l5.436-5.932l6.027,5.554
          c0.165-0.709,0.236-1.465,0.165-2.103C247.359,87.896,246.532,86.194,244.996,84.824z"
        />
      </svg>
    );
  }
}

function Tab({ Icon, editAction, children, showEditButton = true }) {
  return (
    <div className="w-full">
      <div className="hidden sm:flex inline-flex items-center w-full gap-5 [background:#F5F5F5] px-6 py-3 rounded-xl h-[64px]">
        <Icon />

        <div>{children}</div>

        {showEditButton && (
          <button
            onClick={editAction}
            type="button"
            className="text-[#B71922] bg-transparent ml-auto hover:underline"
          >
            Wijzig
          </button>
        )}
      </div>

      <div className="sm:hidden flex items-center justify-between bg-gray-100 px-6 py-3 rounded-xl">
        <div className="flex items-center gap-[10px]">
          <Icon className="mr-2" />
          <div>{children}</div>
        </div>

        {showEditButton && (
          <button
            onClick={editAction}
            type="button"
            className="text-red-600 hover:underline bg-transparent"
          >
            Wijzig
          </button>
        )}
      </div>
    </div>
  );
}

export default function Preview() {
  const { values } = useForm();

  const { setStepIndex, stepIndex } = useSteps();

  const { availability, brand, build, mileage, active_activities } = values;

  const formatMileage = (mileage) => {
    if (mileage || mileage === 0) {
      return mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    } else {
      return "0";
    }
  };


  return (
    <div className="inline-flex w-full flex-col gap-5 p-[6px] mb-[30px]">
      <Tab
        editAction={() => setStepIndex(0)}
        Icon={() => (
          <svg
            width="29"
            height="30"
            className=" shrink-0 bg-white w-12 h-12 rounded-[8px] p-1"
            viewBox="0 0 29 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M27.6188 13.198C27.4492 12.9153 25.7753 12.1923 25.7753 12.1923C26.0664 12.0419 26.2654 12.0108 26.2654 11.389C26.2654 10.7107 26.262 10.4845 25.8098 10.4845H24.2756C24.2693 10.471 24.2626 10.4568 24.2563 10.4427C23.2659 8.27985 23.1331 7.7332 21.656 6.99718C19.6746 6.01186 15.96 5.96211 14.5038 5.96211C13.0475 5.96211 9.33293 6.01186 7.35324 6.99718C5.87441 7.73207 5.91116 8.11026 4.75288 10.4427C4.75288 10.4489 4.74101 10.4653 4.73027 10.4845H3.19434C2.74549 10.4845 2.7421 10.7107 2.7421 11.389C2.7421 12.0108 2.94108 12.0419 3.23222 12.1923C3.23222 12.1923 1.61489 12.9719 1.38877 13.198C1.16264 13.4241 0.936523 15.0069 0.936523 17.7204C0.936523 20.4338 1.16264 23.1473 1.16264 23.1473H1.83762C1.83762 23.9387 1.95407 24.0518 2.29325 24.0518H6.81564C7.15482 24.0518 7.26788 23.9387 7.26788 23.1473H21.7396C21.7396 23.9387 21.8527 24.0518 22.1919 24.0518H26.8273C27.0535 24.0518 27.1665 23.8822 27.1665 23.1473H27.8449C27.8449 23.1473 28.071 20.3773 28.071 17.7204C28.071 15.0635 27.7884 13.4806 27.6188 13.198ZM7.11299 15.7384C6.08346 15.851 5.0486 15.9088 4.0129 15.9114C2.85855 15.9114 2.81898 15.9855 2.73758 15.2647C2.70695 14.9348 2.71664 14.6024 2.76641 14.2749L2.80202 14.1025H2.97161C3.64997 14.1025 4.28707 14.1313 5.49003 14.4857C6.10189 14.6693 6.67737 14.9574 7.191 15.3371C7.43748 15.5157 7.49401 15.6853 7.49401 15.6853L7.11299 15.7384ZM21.085 19.8086L20.8351 20.4338H8.17237C8.17237 20.4338 8.19441 20.3994 7.88972 19.8018C7.6636 19.3598 7.94625 19.0771 8.3934 18.9166C9.25944 18.6045 11.7903 17.7204 14.5038 17.7204C17.2172 17.7204 19.7984 18.4824 20.6373 18.9166C20.9482 19.0771 21.3343 19.1902 21.085 19.812V19.8086ZM6.55673 12.0906C6.37414 12.1011 6.19115 12.1024 6.00839 12.0945C6.15594 11.8322 6.2379 11.5399 6.38206 11.2347C6.8343 10.2737 7.35155 9.18603 8.27243 8.72757C9.60315 8.06504 12.3613 7.76656 14.5038 7.76656C16.6462 7.76656 19.4044 8.06278 20.7351 8.72757C21.656 9.18603 22.1709 10.2742 22.6254 11.2347C22.7707 11.5428 22.8516 11.8373 23.0031 12.1013C22.89 12.1075 22.76 12.1013 22.4496 12.0906H6.55673ZM26.2134 15.2625C26.0924 15.968 26.2055 15.9114 24.9946 15.9114C23.9589 15.9088 22.9241 15.851 21.8945 15.7384C21.7334 15.7096 21.6876 15.4377 21.8165 15.3371C22.3276 14.9531 22.9039 14.6647 23.5175 14.4857C24.7205 14.1313 25.3977 14.0838 26.0664 14.1076C26.1114 14.1092 26.1541 14.1276 26.1863 14.1588C26.2186 14.1901 26.2381 14.2323 26.2411 14.2771C26.2731 14.6062 26.2638 14.938 26.2134 15.2647V15.2625Z"
              fill="#070707"
            />
          </svg>
        )}
        showEditButton={stepIndex !== 3}
      >
        <p className="font-semibold ">{brand + " " + build}</p>

        <p className="text-[14px]">Kilometerstand: {formatMileage(mileage)}</p>
      </Tab>

      {stepIndex !== 1 && active_activities.length > 0 && (
        <div className="bg-[#F5F5F5] py-3 px-6 w-full flex flex-col items-center rounded-xl">
          <div
            className={`w-full flex flex-col sm:flex-row sm:flex-wrap ${active_activities.length === 1
                ? "justify-center"
                : "justify-start"
              }`}
          >
            {active_activities.map((activity, index) => (
              <div
                className={`p-1 ${active_activities.length === 1 ? "w-full" : "sm:w-1/2"
                  }`}
                key={index}
              >
                <div className="flex items-center gap-3 p-2 rounded-xl bg-[#efefef]">
                  <div className="bg-white w-12 h-12 rounded-[8px] p-1">
                    {showIcon(activity.Name)}
                  </div>
                  <p className="font-semibold ml-2">{activity.Name}</p>
                </div>
              </div>
            ))}
          </div>

          {stepIndex !== 3 && (
            <button
              onClick={() => setStepIndex(1)}
              className="text-[#B71922] bg-transparent ml-auto hover:underline">
              Wijzig
            </button>
          )}
        </div>
      )}

      {stepIndex !== 1 && availability && (
        <Tab Icon={() => <></>} editAction={() => setStepIndex(1)} showEditButton={stepIndex !== 3}>
          <div className="flex items-center gap-[20px]">
            <svg
              width="29"
              height="29"
              viewBox="0 0 29 29"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="bg-white w-12 h-12 rounded-[8px] p-[8.64px]"
            >
              <g clipPath="url(#clip0_157_4392)">
                <path
                  d="M19.6667 17.0608L15.6233 14.0282V7.85091C15.6233 7.22978 15.1213 6.72772 14.5001 6.72772C13.879 6.72772 13.377 7.22978 13.377 7.85091V14.5899C13.377 14.9437 13.5432 15.2773 13.8262 15.4884L18.3188 18.8579C18.521 19.0096 18.7569 19.0826 18.9916 19.0826C19.3342 19.0826 19.6711 18.9287 19.8913 18.6322C20.2643 18.1368 20.1632 17.4326 19.6667 17.0608Z"
                  fill="#070707"
                />
                <path
                  d="M14.5 0C6.50421 0 0 6.50421 0 14.5C0 22.4958 6.50421 29 14.5 29C22.4958 29 29 22.4958 29 14.5C29 6.50421 22.4958 0 14.5 0ZM14.5 26.7537C7.74419 26.7537 2.24631 21.2558 2.24631 14.5C2.24631 7.74419 7.74419 2.24631 14.5 2.24631C21.2569 2.24631 26.7537 7.74419 26.7537 14.5C26.7537 21.2558 21.2558 26.7537 14.5 26.7537Z"
                  fill="#070707"
                />
              </g>
              <defs>
                <clipPath id="clip0_157_4392">
                  <rect width="29" height="29" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <p className="font-semibold">
              {dateToHumanReadableString(availability.Date)}
            </p>
          </div>
        </Tab>
      )}
    </div>
  );
}
